import { IAddressV2 } from '@carm/shared/components/form-elements/models';

export enum AppealContactCategoryEnum {
    Corporation = 'ZCORPREP',
    Individual = 'ZINDREP'
}

export interface IAppealContactInfo {
    contactCategory: string;
    contactType: string;
    individual?: {
        firstName: string;
        lastName: string;
    };
    company?: {
        name: string;
        contact: string;
    };
    address: IAddressV2;
    registerForEmail?: string;
    email?: string;
    displayUserName?: string;
    certify?: boolean;
}
